{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2016                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCPlannerDatabaseAdapter;

interface

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

uses
  Classes, WEBLib.TMSFNCPlanner, WEBLib.TMSFNCPlannerData,
  WEBLib.TMSFNCRecurrencyHandler, {%H-}WEBLib.TMSFNCTypes, SysUtils
  {$IFDEF LCLWEBLIB}
  , DB
  {$ENDIF}
  {$IFNDEF LCLWEBLIB}
  , Data.DB
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 1; // Release nr.
  BLD_VER = 1; // Build nr.

  // version history
  // v1.0.0.0 : first release
  // v1.0.0.1 : Fixed : Issue with access violation during scrolling in combination with TDBGrid
  // v1.0.1.0 : New : OnFieldsToResource, OnResourceToFields, OnLocateItem for combination with calculated fields
  // v1.0.1.1 : Fixed : Issue with event naming

type
  TTMSFNCPlannerDatabaseAdapterItemSource = class;

  TTMSFNCPlannerDatabaseAdapter = class;

  TTMSFNCPlannerDatabaseAdapterItemDataLink = class(TDataLink)
  private
    FItem: TTMSFNCPlannerDatabaseAdapterItemSource;
  protected
    procedure ActiveChanged; override;
    procedure DataSetChanged; override;
    procedure DataSetScrolled(Distance: Integer); override;
    procedure RecordChanged(Field: TField); override;
    function Adapter: TTMSFNCPlannerAdapter;
  public
    constructor Create(AItem: TTMSFNCPlannerDatabaseAdapterItemSource);
    destructor Destroy; override;
  end;

  TTMSFNCPlannerDatabaseAdapterItemSource = class(TPersistent)
  private
    FRecurrencyHandler: TTMSFNCRecurrencyHandler;
    FUpdateCount: Integer;
    FDataLink: TTMSFNCPlannerDatabaseAdapterItemDataLink;
    FAdapter: TTMSFNCPlannerAdapter;
    FTitle: String;
    FText: String;
    FDBKey: String;
    FStartTime: String;
    FEndTime: String;
    FResource: String;
    FAutoIncrementDBKey: Boolean;
    FRecurrency: string;
    procedure SetText(const Value: String);
    procedure SetTitle(const Value: String);
    function GetDataSource: TDataSource;
    procedure SetDataSource(const Value: TDataSource);
    procedure SetDBKey(const Value: String);
    procedure SetEndTime(const Value: String);
    procedure SetStartTime(const Value: String);
    procedure SetResource(const Value: String);
    procedure SetAutoIncrementDBKey(const Value: Boolean);
    procedure SetRecurrency(const Value: string);
  protected
    function CheckDataSet: Boolean;
    procedure ClearItems(ADBKey: String; ADeleteItem: TTMSFNCPlannerItem = nil);
    procedure DeleteItem(AItem: TTMSFNCPlannerItem);
    procedure LocateItem(ADataSet: TDataSet; AItem: TTMSFNCPlannerItem);
    procedure InsertItem(AItem: TTMSFNCPlannerItem);
    procedure SelectItem(AItem: TTMSFNCPlannerItem);
    procedure ReadItem(AItem: TTMSFNCPlannerItem);
    procedure WriteItem(AItem: TTMSFNCPlannerItem);
    procedure BeginUpdate; virtual;
    procedure EndUpdate; virtual;
    function IsUpdating: Boolean; virtual;
  public
    constructor Create(AAdapter: TTMSFNCPlannerAdapter);
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
  published
    property DataSource: TDataSource read GetDataSource write SetDataSource;
    property Title: String read FTitle write SetTitle;
    property Text: String read FText write SetText;
    property StartTime: String read FStartTime write SetStartTime;
    property EndTime: String read FEndTime write SetEndTime;
    property Resource: String read FResource write SetResource;
    property DBKey: String read FDBKey write SetDBKey;
    property Recurrency: string read FRecurrency write SetRecurrency;
    property AutoIncrementDBKey: Boolean read FAutoIncrementDBKey write SetAutoIncrementDBKey default True;
  end;

  TTMSFNCPlannerDatabaseAdapterItemLocateEvent = procedure(Sender: TObject; AItem: TTMSFNCPlannerItem) of object;
  TTMSFNCPlannerDatabaseAdapterItemToFields = procedure(Sender: TObject; AItem: TTMSFNCPlannerItem; AFields: TFields) of object;
  TTMSFNCPlannerDatabaseAdapterFieldsToItem = procedure(Sender: TObject; AFields: TFields; AItem: TTMSFNCPlannerItem) of object;
  TTMSFNCPlannerDatabaseAdapterResourceToFieldsEvent = procedure(Sender: TObject; AResource: Integer; AFields: TFields; AColumnField: TField) of object;
  TTMSFNCPlannerDatabaseAdapterFieldsToResourceEvent = procedure(Sender: TObject; AFields: TFields; AColumnField: TField; var AResource: Integer; var AAcceptItem: Boolean) of object;
  TTMSFNCPlannerDatabaseAdapterItemCreateDBKeyEvent = procedure(Sender: TObject; AItem: TTMSFNCPlannerItem; var ADBKey: string) of object;
  TTMSFNCPlannerDatabaseAdapterItemEvent = procedure(Sender: TObject; AItem: TTMSFNCPlannerItem) of object;
  TTMSFNCPlannerDatabaseAdapterItemsLoadedEvent = TNotifyEvent;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCPlannerDatabaseAdapter = class(TTMSFNCPlannerAdapter)
  private
    FItem: TTMSFNCPlannerDatabaseAdapterItemSource;
    FOnFieldsToItem: TTMSFNCPlannerDatabaseAdapterFieldsToItem;
    FOnItemToFields: TTMSFNCPlannerDatabaseAdapterItemToFields;
    FOnItemCreateDBKey: TTMSFNCPlannerDatabaseAdapterItemCreateDBKeyEvent;
    FOnItemUpdated: TTMSFNCPlannerDatabaseAdapterItemEvent;
    FOnItemsLoaded: TTMSFNCPlannerDatabaseAdapterItemsLoadedEvent;
    FOnItemInserted: TTMSFNCPlannerDatabaseAdapterItemEvent;
    FOnItemRead: TTMSFNCPlannerDatabaseAdapterItemEvent;
    FOnFieldsToResource: TTMSFNCPlannerDatabaseAdapterFieldsToResourceEvent;
    FOnResourceToFields: TTMSFNCPlannerDatabaseAdapterResourceToFieldsEvent;
    FOnItemLocate: TTMSFNCPlannerDatabaseAdapterItemLocateEvent;
    procedure SetItem(const Value: TTMSFNCPlannerDatabaseAdapterItemSource);
  protected
    function GetDocURL: string; override;
    procedure RegisterRuntimeClasses; override;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure CreateOrReadDBItem(AStartTime, AEndTime: TDateTime; AItem: TTMSFNCPlannerItem = nil); virtual;
    procedure ClearDBItems(ADBKey: String; ADeleteItem: TTMSFNCPlannerItem = nil);
    procedure ReadDBItem(AItem: TTMSFNCPlannerItem); virtual;
    procedure WriteDBItem(AItem: TTMSFNCPlannerItem); virtual;
    procedure DoItemToFields(AItem: TTMSFNCPlannerItem; AFields: TFields); virtual;
    procedure DoResourceToFields(AResource: Integer; AFields: TFields; AColumnField: TField); virtual;
    procedure DoFieldsToItem(AFields: TFields; AItem: TTMSFNCPlannerItem); virtual;
    procedure DoFieldsToResource(AFields: TFields; AColumnField: TField; var AResource: Integer; var AAcceptItem: Boolean); virtual;
    procedure DoItemCreateDBKey(AItem: TTMSFNCPlannerItem; var ADBKey: String); virtual;
    procedure DoItemInserted(AItem: TTMSFNCPlannerItem); virtual;
    procedure DoItemUpdated(AItem: TTMSFNCPlannerItem); virtual;
    procedure DoItemRead(AItem: TTMSFNCPlannerItem); virtual;
    procedure DoItemsLoaded; virtual;
    function CreateKey: string; virtual;
    function GetVersion: string; override;
  public
    procedure GetItems(PeriodFrom, PeriodTo: TDateTime); override;
    procedure LoadItems; override;
    procedure DeleteItem(AItem: TTMSFNCPlannerItem); override;
    procedure InsertItem(AItem: TTMSFNCPlannerItem); override;
    procedure ReadItem(AItem: TTMSFNCPlannerItem); virtual;
    procedure UpdateItem(AItem: TTMSFNCPlannerItem); override;
    procedure AfterUpdateItem({%H-}AItem: TTMSFNCPlannerItem); override;
    procedure SelectItem(AItem: TTMSFNCPlannerItem); override;
    constructor Create(AOwner: TComponent); override;
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
  published
    property Version: string read GetVersion;
    property Item: TTMSFNCPlannerDatabaseAdapterItemSource read FItem write SetItem;
    property OnItemToFields: TTMSFNCPlannerDatabaseAdapterItemToFields read FOnItemToFields write FOnItemToFields;
    property OnFieldsToItem: TTMSFNCPlannerDatabaseAdapterFieldsToItem read FOnFieldsToItem write FOnFieldsToItem;
    property OnItemLocate: TTMSFNCPlannerDatabaseAdapterItemLocateEvent read FOnItemLocate write FOnItemLocate;
    property OnItemCreateDBKey: TTMSFNCPlannerDatabaseAdapterItemCreateDBKeyEvent read FOnItemCreateDBKey write FOnItemCreateDBKey;
    property OnItemInserted: TTMSFNCPlannerDatabaseAdapterItemEvent read FOnItemInserted write FOnItemInserted;
    property OnItemUpdated: TTMSFNCPlannerDatabaseAdapterItemEvent read FOnItemUpdated write FOnItemUpdated;
    property OnItemRead: TTMSFNCPlannerDatabaseAdapterItemEvent read FOnItemRead write FOnItemRead;
    property OnItemsLoaded: TTMSFNCPlannerDatabaseAdapterItemsLoadedEvent read FOnItemsLoaded write FOnItemsLoaded;
    property OnResourceToFields: TTMSFNCPlannerDatabaseAdapterResourceToFieldsEvent read FOnResourceToFields write FOnResourceToFields;
    property OnFieldsToResource: TTMSFNCPlannerDatabaseAdapterFieldsToResourceEvent read FOnFieldsToResource write FOnFieldsToResource;
  end;

implementation

uses
  WEBLib.TMSFNCUtils;

{$R TMSFNCPlannerDatabaseAdapter.res}

type
  TTMSFNCCustomPlannerOpen = class(TTMSFNCCustomPlanner);

procedure TTMSFNCPlannerDatabaseAdapter.AfterUpdateItem(
  AItem: TTMSFNCPlannerItem);
begin
end;

procedure TTMSFNCPlannerDatabaseAdapter.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCPlannerDatabaseAdapter then
    FItem.Assign((Source as TTMSFNCPlannerDatabaseAdapter).Item);
end;

procedure TTMSFNCPlannerDatabaseAdapter.ClearDBItems(ADBKey: String; ADeleteItem: TTMSFNCPlannerItem = nil);
begin
  if Assigned(FItem) then
    FItem.ClearItems(ADBKey, ADeleteItem);
end;

constructor TTMSFNCPlannerDatabaseAdapter.Create(AOwner: TComponent);
begin
  inherited;
  FItem := TTMSFNCPlannerDatabaseAdapterItemSource.Create(Self);
end;

procedure TTMSFNCPlannerDatabaseAdapter.DeleteItem(AItem: TTMSFNCPlannerItem);
begin
  if Assigned(FItem) then
  begin
    FItem.DeleteItem(AItem);
    if AItem.Recurrent then
      ClearDBItems(AItem.DBKey, AItem);
  end;
end;

destructor TTMSFNCPlannerDatabaseAdapter.Destroy;
begin
  FItem.Free;
  inherited;
end;

procedure TTMSFNCPlannerDatabaseAdapter.DoResourceToFields(AResource: Integer;
  AFields: TFields; AColumnField: TField);
begin
  if Assigned(OnResourceToFields) then
    OnResourceToFields(Self, AResource, AFields, AColumnField);
end;

procedure TTMSFNCPlannerDatabaseAdapter.DoFieldsToItem(AFields: TFields; AItem: TTMSFNCPlannerItem);
begin
  if Assigned(OnFieldsToItem) then
    OnFieldsToItem(Self, AFields, AItem);
end;

procedure TTMSFNCPlannerDatabaseAdapter.DoFieldsToResource(AFields: TFields;
  AColumnField: TField; var AResource: Integer; var AAcceptItem: Boolean);
begin
  if Assigned(OnFieldsToResource) then
    OnFieldsToResource(Self, AFields, AColumnField, AResource, AAcceptItem);
end;

procedure TTMSFNCPlannerDatabaseAdapter.DoItemCreateDBKey(
  AItem: TTMSFNCPlannerItem; var ADBKey: String);
begin
  if Assigned(OnItemCreateDBKey) then
    OnItemCreateDBKey(Self, AItem, ADBKey)
  else
    ADBKey := CreateKey;
end;

procedure TTMSFNCPlannerDatabaseAdapter.DoItemInserted(
  AItem: TTMSFNCPlannerItem);
begin
  if Assigned(OnItemInserted) then
    OnItemInserted(Self, AItem);
end;

procedure TTMSFNCPlannerDatabaseAdapter.DoItemRead(AItem: TTMSFNCPlannerItem);
begin
  if Assigned(OnItemRead) then
    OnItemRead(Self, AItem);
end;

procedure TTMSFNCPlannerDatabaseAdapter.DoItemsLoaded;
begin
  if Assigned(OnItemsLoaded) then
    OnItemsLoaded(Self);
end;

procedure TTMSFNCPlannerDatabaseAdapter.DoItemToFields(AItem: TTMSFNCPlannerItem; AFields: TFields);
begin
  if Assigned(OnItemToFields) then
    OnItemToFields(Self, AItem, AFields);
end;

procedure TTMSFNCPlannerDatabaseAdapter.DoItemUpdated(
  AItem: TTMSFNCPlannerItem);
begin
  if Assigned(OnItemUpdated) then
    OnItemUpdated(Self, AItem);
end;

function TTMSFNCPlannerDatabaseAdapter.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfncuipack/components/ttmsfncplanner/#databinding';
end;

procedure TTMSFNCPlannerDatabaseAdapter.GetItems(PeriodFrom,
  PeriodTo: TDateTime);
var
  ds: TDataSet;
  b: TBookmark;
begin
  if not Assigned(Planner) then
    Exit;

  if not Item.CheckDataSet then
    Exit;

  if Item.IsUpdating then
    Exit;

  Item.BeginUpdate;
  ds := Item.DataSource.DataSet;
  if Assigned(ds) then
  begin
    Planner.BeginUpdate;
    ds.DisableControls;
    b := ds.GetBookmark;
    ds.First;
    while not ds.Eof do
    begin
      CreateOrReadDBItem(PeriodFrom, PeriodTo);
      ds.Next;
    end;
    if ds.BookmarkValid(b) then
      ds.GotoBookmark(b);

    ds.EnableControls;
    ds.FreeBookmark(b);
    Planner.EndUpdate;
  end;
  Item.EndUpdate;

  DoItemsLoaded;
end;

function TTMSFNCPlannerDatabaseAdapter.GetVersion: string;
begin
  Result := GetVersionNumber(MAJ_VER, MIN_VER, REL_VER, BLD_VER);
end;

procedure TTMSFNCPlannerDatabaseAdapter.InsertItem(AItem: TTMSFNCPlannerItem);
begin
  if Assigned(FItem) then
    FItem.InsertItem(AItem);
end;

procedure TTMSFNCPlannerDatabaseAdapter.LoadItems;
var
  p: TTMSFNCCustomPlannerOpen;
begin
  if not Assigned(Planner) then
    Exit;

  p := TTMSFNCCustomPlannerOpen(Planner);

  p.BeginUpdate;
  p.Items.Clear;

  if Active then
    GetItems(p.DisplayStartDateTime, p.DisplayEndDateTime);

  p.EndUpdate;
end;

procedure TTMSFNCPlannerDatabaseAdapter.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and Assigned(FItem) and (AComponent = FItem.DataSource) then
     FItem.DataSource := nil;
end;

procedure TTMSFNCPlannerDatabaseAdapter.SelectItem(AItem: TTMSFNCPlannerItem);
begin
  if Assigned(FItem) then
    FItem.SelectItem(AItem);
end;

procedure TTMSFNCPlannerDatabaseAdapter.SetItem(
  const Value: TTMSFNCPlannerDatabaseAdapterItemSource);
begin
  FItem.Assign(Value);
end;

procedure TTMSFNCPlannerDatabaseAdapter.ReadDBItem(AItem: TTMSFNCPlannerItem);
begin
  if not Assigned(AItem) then
    Exit;

  if AItem.Recurrent then
  begin
    ClearDBItems(AItem.DBKey);
    CreateOrReadDBItem(Planner.DisplayStartDateTime, Planner.DisplayEndDateTime);
  end
  else
    CreateOrReadDBItem(Planner.DisplayStartDateTime, Planner.DisplayEndDateTime, AItem);
end;

procedure TTMSFNCPlannerDatabaseAdapter.ReadItem(AItem: TTMSFNCPlannerItem);
begin
  if Assigned(FItem) then
    FItem.ReadItem(AItem);
end;

procedure TTMSFNCPlannerDatabaseAdapter.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCPlannerDatabaseAdapter);
end;

procedure TTMSFNCPlannerDatabaseAdapter.UpdateItem(AItem: TTMSFNCPlannerItem);
begin
  if Assigned(FItem) then
  begin
    FItem.WriteItem(AItem);
    if AItem.Recurrent then
    begin
      FItem.ClearItems(AItem.DBKey);
      CreateOrReadDBItem(Planner.DisplayStartDateTime, Planner.DisplayEndDateTime);
    end;
  end;
end;

procedure TTMSFNCPlannerDatabaseAdapter.WriteDBItem(AItem: TTMSFNCPlannerItem);
var
  ft, fn, fstart, fend, fdbkey, fres, frecurr: TField;
  ds: TDataSet;
  it: TTMSFNCPlannerItem;
  dts, dte: TDateTime;
begin
  if not Assigned(AItem) then
    Exit;

  ds := Item.DataSource.DataSet;
  if Assigned(ds) then
  begin
    fdbkey := nil;
    if Item.DBKey <> '' then
      fdbkey := ds.FieldByName(Item.DBKey);

    ft := nil;
    if Item.Title <> '' then
      ft := ds.FieldByName(Item.Title);

    fn := nil;
    if Item.Text <> '' then
      fn := ds.FieldByName(Item.Text);

    fstart := nil;
    if Item.StartTime <> '' then
      fstart := ds.FieldByName(Item.StartTime);

    fend := nil;
    if Item.EndTime <> '' then
      fend := ds.FieldByName(Item.EndTime);

    fres := nil;
    if Item.Resource <> '' then
      fres := ds.FieldByName(Item.Resource);

    frecurr := nil;
    if Item.Recurrency <> '' then
      frecurr := ds.FieldByName(Item.Recurrency);

    if Assigned(fdbkey) and Assigned(fstart) and Assigned(fend) then
    begin
      it := AItem;
      if it.Recurrent then
      begin
        dts := it.MasterStartDateTime + (it.StartTime - it.OldStartTime);
        dte := it.MasterEndDateTime + (it.EndTime - it.OldEndTime);
      end
      else
      begin
        dts := it.StartTime;
        dte := it.EndTime;
      end;

      if not fstart.ReadOnly then      
        fstart.AsDateTime := dts;

      if not fend.ReadOnly then      
        fend.AsDateTime := dte;
        
      if Assigned(ft) then
      begin
        if not ft.ReadOnly then
          ft.AsString := it.Title;
      end;

      if Assigned(fn) then
      begin
        if not fn.ReadOnly then
          fn.AsString := it.Text;
      end;
      
      if Assigned(fres) then
      begin
        if not fres.ReadOnly then        
          fres.AsInteger := it.Resource;
      end;
      
      if Assigned(frecurr) then
      begin
        if not frecurr.ReadOnly then
          frecurr.AsString := it.Recurrency;
      end;

      if Assigned(fres) then
        DoResourceToFields(it.Resource, ds.Fields, fres);

      DoItemToFields(it, ds.Fields);
    end;
  end;
end;

procedure TTMSFNCPlannerDatabaseAdapter.CreateOrReadDBItem(AStartTime, AEndTime: TDateTime; AItem: TTMSFNCPlannerItem = nil);
var
  ft, fn, fstart, fend, fdbkey, fres, frecurr: TField;
  ds: TDataSet;
  it: TTMSFNCPlannerItem;
  c: Boolean;
  dts, dte, dtsm, dtem: TDateTime;
  r: Integer;
  a: Boolean;
begin
  ds := Item.DataSource.DataSet;
  if Assigned(ds) then
  begin
    if Assigned(Planner) then
      Planner.BeginUpdate;

    fdbkey := nil;
    if Item.DBKey <> '' then
      fdbkey := ds.FieldByName(Item.DBKey);

    ft := nil;
    if Item.Title <> '' then
      ft := ds.FieldByName(Item.Title);

    fn := nil;
    if Item.Text <> '' then
      fn := ds.FieldByName(Item.Text);

    fstart := nil;
    if Item.StartTime <> '' then
      fstart := ds.FieldByName(Item.StartTime);

    fend := nil;
    if Item.EndTime <> '' then
      fend := ds.FieldByName(Item.EndTime);

    fres := nil;
    if Item.Resource <> '' then
      fres := ds.FieldByName(Item.Resource);

    frecurr := nil;
    if Item.Recurrency <> '' then
      frecurr := ds.FieldByName(Item.Recurrency);

    if Assigned(fdbkey) and Assigned(fstart) and Assigned(fend) then
    begin
      dts := fstart.AsDateTime;
      dte := fend.AsDateTime;
      dtsm := dts;
      dtem := dte;

      if Assigned(frecurr) then
        Item.FRecurrencyHandler.Recurrency := frecurr.AsString
      else
        Item.FRecurrencyHandler.Recurrency := '';

      Item.FRecurrencyHandler.StartTime := dts;
      Item.FRecurrencyHandler.EndTime := dte;
      Item.FRecurrencyHandler.TimeSpan := 0;
      Item.FRecurrencyHandler.Generate;

      while Item.FRecurrencyHandler.NextDate(dts, dte) do
      begin
        c := True;
        if Assigned(fstart) and Assigned(fend) then
          if (not DateTimeInRangeEx(dts, AStartTime, AEndTime, False) and not DateTimeInRangeEx(dte, AStartTime, AEndTime, False) and not (DateTimeInRangeEx(dts + (dte - dts) / 2, AStartTime, AEndTime, False))) then
            c := False;

        if c then
        begin
          r := -1;
          if Assigned(fres) then
            r := fres.AsInteger;

          a := True;

          if Assigned(fres) then
            DoFieldsToResource(ds.Fields, fres, r, a);

          if a then
          begin
	          if Assigned(AItem) then
	            it := AItem
	          else
	            it := TTMSFNCCustomPlannerOpen(Planner).Items.Add;

	          it.BeginUpdate;
	          it.MasterStartDateTime := dtsm;
	          it.MasterEndDateTime := dtem;
	          it.Recurrent := Item.FRecurrencyHandler.IsRecurrent;
	          it.Recurrency := Item.FRecurrencyHandler.Recurrency;
	          it.StartTime := dts;
	          it.EndTime := dte;
	          it.DBKey := fdbkey.AsString;
	          if Assigned(ft) then
	            it.Title := ft.AsString;
	          if Assigned(fn) then
	            it.Text := fn.AsString;
	          if Assigned(fres) then
	            it.Resource := r;

	          DoFieldsToItem(ds.Fields, it);
	          it.OldStartTime := it.StartTime;
	          it.OldEndTime := it.EndTime;

	          it.EndUpdate;

	          DoItemRead(it);
          end;
        end;
      end;
    end;
    if Assigned(Planner) then
      Planner.EndUpdate;
  end;
end;

function TTMSFNCPlannerDatabaseAdapter.CreateKey: string;
{$IFDEF LCLWEBLIB}
var
  g: TGUID;
{$ENDIF}
begin
  {$IFNDEF LCLWEBLIB}
  Result := TGuid.NewGuid.ToString;
  {$ENDIF}
  {$IFDEF LCLWEBLIB}
  CreateGUID(g);
  Result := GUIDToString(g);
  {$ENDIF}
end;

{ TTMSFNCPlannerDatabaseAdapterItemDataLink }

procedure TTMSFNCPlannerDatabaseAdapterItemDataLink.ActiveChanged;
var
  a: TTMSFNCPlannerAdapter;
begin
  inherited;
  a := Adapter;
  if Assigned(a) then
    a.LoadItems;
end;

function TTMSFNCPlannerDatabaseAdapterItemDataLink.Adapter: TTMSFNCPlannerAdapter;
begin
  Result := nil;
  if Assigned(FItem) then
    Result := FItem.FAdapter;
end;

constructor TTMSFNCPlannerDatabaseAdapterItemDataLink.Create(AItem: TTMSFNCPlannerDatabaseAdapterItemSource);
begin
  FItem := AItem;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemDataLink.DataSetChanged;
begin
  inherited;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemDataLink.DataSetScrolled(Distance: Integer);
begin
  inherited;
end;

destructor TTMSFNCPlannerDatabaseAdapterItemDataLink.Destroy;
begin

  inherited;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemDataLink.RecordChanged(Field: TField);
var
  fdbkey: TField;
  a: TTMSFNCPlannerAdapter;
  it: TTMSFNCPlannerItem;
begin
  inherited;

  a := Adapter;
  if Assigned(a) and not a.Active then
    Exit;

  if not FItem.CheckDataSet or FItem.IsUpdating then
    Exit;

  FItem.BeginUpdate;
  if Assigned(DataSet) then
  begin
    if DataSet.Active then
    begin
      if DataSet.State = dsBrowse then
      begin
        fdbkey := nil;
        if FItem.DBKey <> '' then
          fdbkey := DataSet.FieldByName(FItem.DBKey);

        if Assigned(fdbkey) then
        begin
          it := nil;
          if Assigned(a.Planner) then
            it := a.Planner.FindItemWithDBKey(fdbkey.AsString);
          if Assigned(it) then
          begin
            if a is TTMSFNCPlannerDatabaseAdapter then
              (a as TTMSFNCPlannerDatabaseAdapter).ReadDBItem(it);
            if Assigned(a.Planner) then
              a.Planner.SelectItem(it);
          end;
        end;
      end;
    end;
  end;
  FItem.EndUpdate;
end;

{ TTMSFNCPlannerDatabaseAdapterItemSource }

procedure TTMSFNCPlannerDatabaseAdapterItemSource.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCPlannerDatabaseAdapterItemSource then
  begin
    DataSource := (Source as TTMSFNCPlannerDatabaseAdapterItemSource).DataSource;
    FTitle := (Source as TTMSFNCPlannerDatabaseAdapterItemSource).Title;
    FText := (Source as TTMSFNCPlannerDatabaseAdapterItemSource).Title;
    FStartTime := (Source as TTMSFNCPlannerDatabaseAdapterItemSource).StartTime;
    FEndTime := (Source as TTMSFNCPlannerDatabaseAdapterItemSource).EndTime;
    FResource := (Source as TTMSFNCPlannerDatabaseAdapterItemSource).Resource;
    FDBKey := (Source as TTMSFNCPlannerDatabaseAdapterItemSource).DBKey;
    FRecurrency := (Source as TTMSFNCPlannerDatabaseAdapterItemSource).Recurrency;
    FAutoIncrementDBKey := (Source as TTMSFNCPlannerDatabaseAdapterItemSource).AutoIncrementDBKey;
  end;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.BeginUpdate;
begin
  Inc(FUpdateCount);
end;

function TTMSFNCPlannerDatabaseAdapterItemSource.CheckDataSet: Boolean;
begin
  Result := False;

  if (DBKey = '') or (StartTime = '') or (EndTime = '') then
  begin
    raise Exception.Create('DBKey, StartTime and EndTime are not set in TTMSFNCPlannerDatabaseAdapter item source.');
    Exit;
  end;

  if Assigned(DataSource) then
    if Assigned(DataSource.DataSet) then
      Result := DataSource.DataSet.Active;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.ClearItems(ADBKey: String; ADeleteItem: TTMSFNCPlannerItem = nil);
var
  i: Integer;
  a: TTMSFNCPlannerAdapter;
  it: TTMSFNCPlannerItem;
begin
  a := FAdapter;
  if not Assigned(a) then
    Exit;

  if Assigned(a.Planner) then
  begin
    a.Planner.BeginUpdate;
    for I := TTMSFNCCustomPlannerOpen(a.Planner).Items.Count - 1 downto 0 do
    begin
      it := TTMSFNCCustomPlannerOpen(a.Planner).Items[i];
      if (it.DBKey = ADBKey) and (it <> ADeleteItem) then
        TTMSFNCCustomPlannerOpen(a.Planner).Items.Delete(I);
    end;
    a.Planner.EndUpdate;
  end;
end;

constructor TTMSFNCPlannerDatabaseAdapterItemSource.Create(AAdapter: TTMSFNCPlannerAdapter);
begin
  FUpdateCount := 0;
  FAutoIncrementDBKey := True;
  FAdapter := AAdapter;
  FRecurrencyHandler := TTMSFNCRecurrencyHandler.Create;
  FDataLink := TTMSFNCPlannerDatabaseAdapterItemDataLink.Create(Self);
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.DeleteItem(
  AItem: TTMSFNCPlannerItem);
var
  ds: TDataSet;
begin
  if not CheckDataSet or not Assigned(AItem) then
    Exit;

  if IsUpdating then
    Exit;

  BeginUpdate;
  ds := DataSource.DataSet;
  if Assigned(ds) then
  begin
    ds.DisableControls;
    LocateItem(ds, AItem);        
    try
      ds.Delete;
    except
      ds.EnableControls;
      EndUpdate;
      raise Exception.Create('Could not delete record from dataset.');
    end;
    ds.EnableControls;
  end;
  EndUpdate;
end;

destructor TTMSFNCPlannerDatabaseAdapterItemSource.Destroy;
begin
  FDataLink.Free;
  FRecurrencyHandler.Free;
  inherited;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.EndUpdate;
begin
  Dec(FUpdateCount);
end;

function TTMSFNCPlannerDatabaseAdapterItemSource.GetDataSource: TDataSource;
begin
  Result := FDataLink.DataSource;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.InsertItem(AItem: TTMSFNCPlannerItem);
var
  ds: TDataSet;
  b: TBookmark;
  k: String;
  fdbk: TField;
begin
  if not CheckDataSet then
    Exit;

  BeginUpdate;
  ds := DataSource.DataSet;
  if Assigned(ds) then
  begin
    ds.DisableControls;
    b := ds.GetBookmark;
    try
      try
        ds.Append;
      except
        if ds.BookmarkValid(b) then
          ds.GotoBookmark(b);

        ds.EnableControls;
        ds.FreeBookmark(b);
        EndUpdate;
        raise Exception.Create('Could not append new record.');
      end;

      fdbk := nil;
      if DBKey <> '' then
        fdbk := ds.FieldByName(DBKey);

      if not AutoIncrementDBKey then
      begin
        k := AItem.DBKey;
        if Assigned(FAdapter) and (FAdapter is TTMSFNCPlannerDatabaseAdapter) then
          (FAdapter as TTMSFNCPlannerDatabaseAdapter).DoItemCreateDBKey(AItem, k);

        if Assigned(fdbk) then
          fdbk.AsString := k;
      end;

      if Assigned(fdbk) then
        AItem.DBKey := fdbk.AsString;

      WriteItem(AItem);
      AItem.DBKey := fdbk.AsString;
    finally
      if ds.BookmarkValid(b) then
        ds.GotoBookmark(b);

      ds.EnableControls;
      ds.FreeBookmark(b);
    end;
  end;
  EndUpdate;

  if Assigned(FAdapter) and (FAdapter is TTMSFNCPlannerDatabaseAdapter) and not IsUpdating then
    (FAdapter as TTMSFNCPlannerDatabaseAdapter).DoItemInserted(AItem);
end;

function TTMSFNCPlannerDatabaseAdapterItemSource.IsUpdating: Boolean;
begin
  Result := FUpdateCount > 0;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.LocateItem(ADataSet: TDataSet; AItem: TTMSFNCPlannerItem);
begin
  if Assigned((FAdapter as TTMSFNCPlannerDatabaseAdapter).OnItemLocate) then
    (FAdapter as TTMSFNCPlannerDatabaseAdapter).OnItemLocate(Self, AItem)
  else
  begin
    if Assigned(ADataSet) then  
      ADataSet.Locate(DBKey, AItem.DBKey, []);
  end;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.ReadItem(AItem: TTMSFNCPlannerItem);
var
  ds: TDataSet;
  b: TBookmark;
begin
  if not CheckDataSet or not Assigned(AItem) then
    Exit;

  BeginUpdate;
  ds := DataSource.DataSet;
  if Assigned(ds) then
  begin
    ds.DisableControls;
    b := ds.GetBookmark;
    try
      if ds.State = dsBrowse then
        LocateItem(ds, AItem);

      if FAdapter is TTMSFNCPlannerDatabaseAdapter then
        (FAdapter as TTMSFNCPlannerDatabaseAdapter).ReadDBItem(AItem);
    finally
      if ds.BookmarkValid(b) then
        ds.GotoBookmark(b);

      ds.EnableControls;
      ds.FreeBookmark(b);
    end;
  end;
  EndUpdate;

  if Assigned(FAdapter) and (FAdapter is TTMSFNCPlannerDatabaseAdapter) and not IsUpdating then
    (FAdapter as TTMSFNCPlannerDatabaseAdapter).DoItemRead(AItem);
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.SelectItem(AItem: TTMSFNCPlannerItem);
var
  ds: TDataSet;
begin
  if not CheckDataSet or not Assigned(AItem) then
    Exit;

  if IsUpdating then
    Exit;

  BeginUpdate;
  ds := DataSource.DataSet;
  LocateItem(ds, AItem);
  EndUpdate;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.SetAutoIncrementDBKey(
  const Value: Boolean);
begin
  FAutoIncrementDBKey := Value;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.SetDataSource(const Value: TDataSource);
begin
  if FDataLink.DataSource <> Value then
    FDataLink.DataSource := Value;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.SetDBKey(const Value: String);
begin
  FDBKey := Value;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.SetEndTime(const Value: String);
begin
  FEndTime := Value;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.SetRecurrency(
  const Value: string);
begin
  FRecurrency := Value;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.SetResource(
  const Value: String);
begin
  FResource := Value;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.SetStartTime(const Value: String);
begin
  FStartTime := Value;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.SetText(const Value: String);
begin
  FText := Value;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.SetTitle(const Value: String);
begin
  FTitle := Value;
end;

procedure TTMSFNCPlannerDatabaseAdapterItemSource.WriteItem(AItem: TTMSFNCPlannerItem);
var
  ds: TDataSet;
  b: TBookmark;
begin
  if not CheckDataSet then
    Exit;

  BeginUpdate;
  ds := DataSource.DataSet;
  if Assigned(ds) then
  begin
    ds.DisableControls;
    b := ds.GetBookmark;
    try
      if ds.State = dsBrowse then
      begin
        try
          LocateItem(ds, AItem);
          ds.Edit;
        except
          if ds.BookmarkValid(b) then
            ds.GotoBookmark(b);

          ds.EnableControls;
          ds.FreeBookmark(b);
          EndUpdate;
          raise Exception.Create('Could not put dataset in edit mode.');
        end;
      end;

      if (ds.State = dsEdit) or (ds.State = dsInsert) then
      begin
        if FAdapter is TTMSFNCPlannerDatabaseAdapter then
         (FAdapter as TTMSFNCPlannerDatabaseAdapter).WriteDBItem(AItem);
        try
          ds.Post;
        except
          if ds.BookmarkValid(b) then
            ds.GotoBookmark(b);

          ds.EnableControls;
          ds.FreeBookmark(b);
          EndUpdate;
          raise Exception.Create('Could not post to dataset.');
        end;
      end;
    finally
      if ds.BookmarkValid(b) then
        ds.GotoBookmark(b);

      ds.EnableControls;
      ds.FreeBookmark(b);
    end;
  end;
  EndUpdate;

  if (FAdapter is TTMSFNCPlannerDatabaseAdapter) and not IsUpdating then
    (FAdapter as TTMSFNCPlannerDatabaseAdapter).DoItemUpdated(AItem);
end;

end.
